<template>
  <v-text-field
    v-model="valueModel"
    :loading="loading"
    class="identifier-input"
    clear-icon="mdi-close-circle-outline"
    clearable
    dense
    direction="ltr"
    hide-details
    outlined
    placeholder="تاریخ انقضا"
    style="direction: ltr"
    type="number"
      @keydown.enter="valueComputed = { ...valueComputed, days: valueModel }"
      @click:clear="valueComputed = { ...valueComputed, days: null }"
  >
    <template v-slot:prepend-inner>
      <v-card
        class="d-flex align-center px-2"
        color="grey lighten-2"
        flat
        height="40"
        width="fit-content"
      >
        <v-menu v-model="menu" bottom nudge-bottom="5" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              :ripple="false"
              class="pa-0"
              style="text-transform: unset"
              text
            >
              <v-fade-transition mode="out-in">
                <v-icon v-if="!menu" key="down" class="ms-1"
                  >mdi-chevron-down</v-icon
                >
                <v-icon v-else key="up" class="ms-1">mdi-chevron-up</v-icon>
              </v-fade-transition>
              <span v-if="!!typeItems && !!typeItems.length">{{
                typeItems[typeModel].name
              }}</span>
              <v-progress-circular
                v-else-if="loading"
                color="primary"
                indeterminate
                size="20"
                width="3"
              />
            </v-btn>
          </template>

          <v-list :disabled="loading" dense min-width="150">
            <v-list-item-group v-model="typeModel" mandatory>
              <template v-for="(item, i) in typeItems">
                <v-list-item :key="i" color="primary">
                  <v-list-item-title>{{ item.name }}</v-list-item-title>
                </v-list-item>
              </template>
            </v-list-item-group>
          </v-list>
        </v-menu>
      </v-card>
    </template>

    <template v-slot:append>
      <v-btn class="mt-n1" icon small @click="valueComputed = { ...valueComputed, days: valueModel }">
        <v-icon>mdi-magnify</v-icon>
      </v-btn>
    </template>
  </v-text-field>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "headerExpireTypeFilter",

  props: {
    value: Object,
  },

  data: () => ({
    loading: false,
    menu: false,
    typeModel: 0,
    typeItems: [
      { name: "بیشتر از", value: "more" },
      { name: "کمتر از", value: "less" },
    ],
    valueModel: null,
  }),

  mounted() {
    if (!!this.valueComputed && this.valueComputed?.expired_Type)
      this.valueComputed.expired_type = this.typeItems[0]?.value;
  },

  computed: {
    valueComputed: {
      get() {
        return this.value;
      },
      set(val) {
          console.log("Updating Store with:", val);
        this.updateExpireTypeFilter(val);
      },
    },
  },

  watch: {
  typeModel(val) {
    if (!!this.valueComputed) {
      this.valueComputed = { 
         ...this.valueComputed, 
         expired_type: this.typeItems[val]?.value 
      };
    }
  },
  },

  methods: {
    ...mapActions("localstorage", ["updateExpireTypeFilter"]),
  },
};
</script>

<style scoped>
.v-input.identifier-input >>> .v-input__slot {
  padding-left: 0 !important;
}

.v-input >>> .v-input__prepend-inner {
  margin: 0 !important;
  padding-left: 0;
  padding-right: 4px;
}

.qr-address-field >>> .v-input__append-inner {
  padding: 0 0 0 4px;
}

.select-dest >>> .v-input__slot {
  padding: 0 !important;
}

.select-dest >>> .v-input__append-inner {
  padding: 0 !important;
  margin: 0 !important;
}

.select-dest >>> .v-select__selection {
  font-size: small !important;
}
</style>
